<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yQIgtL/html/docimages/cover_ader.jpg?1685790699008" alt="This image is the cover for the book 30 Years With Master Nuno Oliveira"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">30 Years With Master Nuno Oliveira
      </h1>
      <p class="bookDescription body article font2">
        <p>This classical text, which knowledgeable horsemen have been anxiously awaiting for years, is finally available in English. Henriquet's personal record of correspondence provides a unique window into the private problem-solving dialogue between master and student. Now a master écuyer in his own right, Henriquet embellishes this new edition with 50 photographs from his personal collection. This first and only English edition includes many more photographs of Nuno Oliveira and his teacher than earlier editions. It has also been embellished with a glossary and a descriptive table of contents for the 71 chapters.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michel Henriquet
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Xenophon Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01d9f34a